export const info = {
    "validate": true,
    "label": "Los datos del contratante son los mismos que los del asegurado",
    "customClass": "checkClassic",
    "tableView": false,
    "defaultValue": true,
    "key": "datosContratanteIgualAsegurado",
    "properties": {
        "autocomplete": "true"
    },
    "type": "checkbox",
    "input": true,
    "value": "personaMoral"
}
export const info2 = {
    "validate": true,
    "label": "Los datos del contratante son los mismos que los del asegurado",
    "customClass": "checkClassic",
    "tableView": false,
    "defaultValue": true,
    "key": "datosContratanteIgualAsegurado",
    "properties": {
        "autocomplete": "true"
    },
    "type": "checkbox",
    "input": true,
    "value": "personaMoral"
}

export const infoDefaultValueFalse = {
    "validate": true,
    "label": "Los datos del contratante son los mismos que los del asegurado",
    "customClass": "checkClassic",
    "tableView": false,
    "defaultValue": false,
    "key": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
    "properties": {
        "autocomplete": "true"
    },
    "type": "checkbox",
    "input": true
}

export const key = "field-step-4-0"
export const current = {
    "primary": {
        "associated_group": "step_emision_contratante",
        "title": [
            {
                "type": "heading6",
                "text": "Datos del contratante",
                "spans": []
            }
        ],
        "description": [],
        "buttonnext": "Si",
        "returnbutton": "Si",
        "sidebar": "Si",
        "enable_email": "No",
        "columns": "2",
        "relationship_columns": "50-50",
        "opciones_servicio": null
    },
    "newItems": [
        {
            "label": "Los datos del contratante son los mismos que los del asegurado",
            "customClass": "checkClassic",
            "tableView": false,
            "defaultValue": true,
            "key": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
            "properties": {
                "autocomplete": "true"
            },
            "type": "checkbox",
            "input": true
        },
        {
            "label": "TIPO DE PERSONA",
            "optionsLabelPosition": "right",
            "customClass": "radioText",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "PERSONA FÍSICA",
                    "value": "personaFisica",
                    "shortcut": ""
                },
                {
                    "label": "PERSONA MORAL",
                    "value": "personaMoral",
                    "shortcut": ""
                }
            ],
            "customDefaultValue": "tipoDePersona",
            "validate": {
                "required": true
            },
            "key": "tipoDePersonaContratante",
            "conditional": {
                "show": true,
                "when": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                "eq": "false"
            },
            "type": "radio",
            "input": true,
            "defaultValue": "personaFisica"
        },
        {
            "label": "RFC",
            "tableView": true,
            "customDefaultValue": "identificadorPersona",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z0-9]+$",
                "customMessage": "Dato no válido"
            },
            "key": "identificadorPersonaContratante",
            "conditional": {
                "show": true,
                "when": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                "eq": "false"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Validar RFC",
            "showValidations": false,
            "tableView": false,
            "key": "validarRfcContratante",
            "conditional": {
                "show": true,
                "when": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                "eq": "false"
            },
            "logic": [
                {
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/personas?tipoIdentificadorPersona=1&identificadorPersonaContratante=value",
                            "method": "GET",
                            "headers": {
                                "Content-Type": "application/json",
                                "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                            },
                            "body": {},
                            "action": "autocomplete",
                            "key": "Contratante"
                        }
                    },
                    "actions": [],
                    "isRowSelected": true
                }
            ],
            "type": "button",
            "input": true,
            "saveOnEnter": false
        },
        {
            "label": "Primer Nombre",
            "tableView": true,
            "customDefaultValue": "primerNombre",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "primerNombreContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Segundo Nombre",
            "tableView": true,
            "customDefaultValue": "segundoNombre",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "segundoNombreContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Apellido paterno",
            "tableView": true,
            "customDefaultValue": "primerApellido",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "primerApellidoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Apellido materno",
            "tableView": true,
            "customDefaultValue": "segundoApellido",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "segundoApellidoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "CURP",
            "tableView": true,
            "customDefaultValue": "curp",
            "validate": {
                "pattern": "^[a-zA-Z0-9]+$",
                "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                "minLength": 18,
                "maxLength": 18
            },
            "key": "curpContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Género",
            "widget": "choicesjs",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Hombre",
                        "value": "H - HOMBRE"
                    },
                    {
                        "label": "Mujer",
                        "value": "M - MUJER"
                    }
                ]
            },
            "customDefaultValue": "sexo",
            "key": "sexoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true
        },
        {
            "label": "Fecha de nacimiento",
            "tableView": true,
            "customDefaultValue": "fechaNacimiento",
            "key": "fechaDeNacimientoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Estado Civil",
            "widget": "choicesjs",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Soltero/a.",
                        "value": "solteroA"
                    },
                    {
                        "label": "Casado/a.",
                        "value": "casadoA"
                    }
                ]
            },
            "customDefaultValue": "estadoCivil",
            "key": "estadoCivilContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true
        },
        {
            "label": "País de Nacimiento",
            "widget": "choicesjs",
            "placeholder": "Elige tu país de nacimiento",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "pais",
            "validate": {
                "customMessage": "Este campo es requerido"
            },
            "key": "paisNacimientoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true
        },
        {
            "label": "Lugar de Nacimiento",
            "placeholder": "Lugar de Nacimiento",
            "tableView": true,
            "customDefaultValue": "lugarNacimiento",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 40
            },
            "key": "lugarNacimientoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Nacionalidad",
            "placeholder": "Nacionalidad",
            "tableView": true,
            "customDefaultValue": "nacionalidad",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "nacionalidadContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Ocupación o profesión",
            "widget": "choicesjs",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "ocupacionProfesion",
            "key": "ocupacionProfesionContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true
        },
        {
            "label": "Puesto",
            "tableView": true,
            "customDefaultValue": "puesto",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "puestoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Ingresos mensuales",
            "tableView": true,
            "customDefaultValue": "ingresosMensuales",
            "validate": {
                "pattern": "^[0-9]*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 7
            },
            "key": "ingresosMensualesContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "¿Empleado gubernamental?",
            "tableView": false,
            "defaultValue": false,
            "customDefaultValue": "empleadoGubernamental",
            "validate": {
                "customMessage": "Error"
            },
            "key": "empleadoGubernamentalContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "checkbox",
            "input": true
        },
        {
            "label": "Descripción de actividades",
            "tableView": true,
            "customDefaultValue": "descripcionActividades",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 70
            },
            "key": "descripcionActividadesContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "INGRESA TU E-MAIL",
            "placeholder": "ejemplo@gmail.com",
            "tableView": true,
            "customDefaultValue": "email",
            "validate": {
                "required": true,
                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                "customMessage": "Ingrese un correo electrónico valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "emailContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "Teléfono particular",
            "placeholder": "Ej. 55 5723 799",
            "tableView": true,
            "customDefaultValue": "telefonoParticular",
            "validate": {
                "required": true,
                "pattern": "1?-?\\(?[0-9]{3}[0-9]{3}[0-9]{4}",
                "customMessage": "Ingresa un número telefónico valido",
                "minLength": 1,
                "maxLength": 10
            },
            "key": "telefonoParticularContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "TELÉFONO CELULAR",
            "placeholder": "Ej. 55 5723 799",
            "tableView": true,
            "customDefaultValue": "telefono",
            "validate": {
                "required": true,
                "pattern": "1?-?\\(?[0-9]{3}[0-9]{3}[0-9]{4}",
                "customMessage": "Ingresa un número telefónico valido",
                "minLength": 1,
                "maxLength": 10
            },
            "key": "telefonoContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "Nombre del apoderado legal ",
            "tableView": true,
            "validate": {
                "customMessage": "Dato no válido",
                "maxLength": 60
            },
            "key": "nombreDelApoderadoLegalContratante",
            "conditional": {
                "show": true,
                "when": "anadirApoderadoLegalContratante",
                "eq": "true"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Fecha de nacimiento del apoderado",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
                "minDate": "1870-01-01T12:00:00-04:56",
                "maxDate": "2021-01-01T12:00:00-05:00",
                "disableWeekends": false,
                "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "validate": {
                "customMessage": "INGRESA UNA FECHA VÁLIDA"
            },
            "key": "fechaDeNacimientoDelApoderadoContratante",
            "conditional": {
                "show": true,
                "when": "anadirApoderadoLegalContratante",
                "eq": "true"
            },
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": true,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2021-01-01T12:00:00-05:00"
            }
        },
        {
            "label": "Añadir apoderado legal",
            "customClass": "checkClassic",
            "tableView": false,
            "defaultValue": false,
            "key": "anadirApoderadoLegalContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaMoral"
            },
            "type": "checkbox",
            "input": true
        },
        {
            "label": "Folio Mercantil ",
            "tableView": true,
            "validate": {
                "pattern": "[a-zA-Z0-9]",
                "customMessage": "Dato no válido",
                "maxLength": 20
            },
            "key": "folioMercantil",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaMoral"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "E.Firma",
            "tableView": true,
            "customDefaultValue": "eFirma",
            "validate": {
                "pattern": "[a-zA-Z0-9]",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 35
            },
            "key": "eFirmaContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "Tipo de identificación entregada",
            "widget": "choicesjs",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Credencial para votar vigente",
                        "value": "credencialParaVotarVigente"
                    },
                    {
                        "label": "Pasaporte vigente",
                        "value": "pasaporteVigente"
                    },
                    {
                        "label": "Cedula profesional",
                        "value": "cedulaProfesional"
                    },
                    {
                        "label": "Cartilla de servicio militar",
                        "value": "cartillaDeServicioMilitar"
                    },
                    {
                        "label": "Certificado de matrícula consultar para extranjeros",
                        "value": "certificadoDeMatriculaConsultarParaExtranjeros"
                    },
                    {
                        "label": "Documento migratorio vigente",
                        "value": "documentoMigratorioVigente"
                    }
                ]
            },
            "customDefaultValue": "tipoDeIdentificacionEntregada",
            "key": "tipoDeIdentificacionEntregadaContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true
        },
        {
            "label": "País y entidad que expide el documento",
            "widget": "choicesjs",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "paisEntidadExpideDocumento",
            "validate": {
                "customMessage": "Este campo es requerido"
            },
            "key": "paisEntidadExpideDocumentoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true
        },
        {
            "label": "Folio de identificación entregada",
            "tableView": true,
            "customDefaultValue": "folioDeIdentificacionEntregada",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "folioDeIdentificacionEntregadaContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "¿Otras nacionalidades?",
            "tableView": false,
            "defaultValue": false,
            "customDefaultValue": "otrasNacionalidades",
            "validate": {
                "customMessage": "Error"
            },
            "key": "otrasNacionalidadesContratante",
            "conditional": {
                "show": false,
                "when": "paisNacimientoContratante",
                "eq": "052"
            },
            "type": "checkbox",
            "input": true
        },
        {
            "label": "¿Cuáles?",
            "tableView": true,
            "customDefaultValue": "cuales",
            "calculateValue": "cuales",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "cualesContratante",
            "conditional": {
                "show": true,
                "when": "otrasNacionalidadesContratante",
                "eq": "true"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "¿Residente fiscal en el extranjero?",
            "tableView": false,
            "defaultValue": false,
            "customDefaultValue": "residenteFiscalExtranjero",
            "validate": {
                "customMessage": "Error"
            },
            "key": "residenteFiscalExtranjeroContratante",
            "conditional": {
                "show": false,
                "when": "paisNacimientoContratante",
                "eq": "052"
            },
            "type": "checkbox",
            "input": true
        },
        {
            "label": "País donde es residente fiscal",
            "widget": "choicesjs",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "paisResidenteFiscal",
            "validate": {
                "customMessage": "Este campo es requerido"
            },
            "key": "paisResidenteFiscalContratante",
            "conditional": {
                "show": true,
                "when": "residenteFiscalExtranjeroContratante",
                "eq": "true"
            },
            "type": "select",
            "input": true
        },
        {
            "label": "N° Identificación en el extranjero",
            "tableView": true,
            "customDefaultValue": "nIdentificacionEnElExtranjero",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "nIdentificacionEnElExtranjeroContratante",
            "conditional": {
                "show": true,
                "when": "residenteFiscalExtranjeroContratante",
                "eq": "true"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Dirección",
            "tableView": true,
            "customDefaultValue": "direccion",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 50
            },
            "key": "direccionContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "No. Exterior",
            "tableView": true,
            "customDefaultValue": "nExterior",
            "validate": {
                "required": true,
                "pattern": "[a-zA-Z0-9]",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 6
            },
            "key": "nExteriorContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "No. interior",
            "tableView": true,
            "customDefaultValue": "nIterior",
            "validate": {
                "pattern": "[a-zA-Z0-9]",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 6
            },
            "key": "nIteriorContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "Código postal",
            "tableView": true,
            "customDefaultValue": "codigoPostal",
            "validate": {
                "required": true,
                "pattern": "^[0-9]*$",
                "customMessage": "MINIMO 5 CARACTERES",
                "minLength": 5,
                "maxLength": 5
            },
            "key": "codigoPostalContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "Estado",
            "tableView": true,
            "customDefaultValue": "estado",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "estadoContratante",
            "type": "textfield",
            "input": true
        },
        {
            "label": "Colonia",
            "widget": "choicesjs",
            "placeholder": "Elige la colonia",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostal=value&catalogo=COLONIA",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "colonia",
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "coloniaContratante",
            "type": "select",
            "input": true
        },
        {
            "label": "Domicilio en el extranjero",
            "tableView": true,
            "customDefaultValue": "domicilioEnElExtranjero",
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 50
            },
            "key": "domicilioEnElExtranjeroContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "País domicilio en el extranjero",
            "widget": "choicesjs",
            "placeholder": "Elige tu país de domicilio en el extranjero",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "validate": {
                "customMessage": "Este campo es requerido"
            },
            "key": "paisDomicilioEnElExtranjeroContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true
        },
        {
            "label": "Teléfono (con clave lada)",
            "tableView": true,
            "customDefaultValue": "telefonoExtranjero",
            "validate": {
                "pattern": "^[0-9]*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 15
            },
            "key": "telefonoExtranjeroContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Razón social",
            "tableView": true,
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "maxLength": 60
            },
            "key": "razonSocialContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaMoral"
            },
            "type": "textfield",
            "input": true
        },
        {
            "label": "Fecha de constitución",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
                "minDate": "1870-01-01T12:00:00-04:56",
                "maxDate": "2021-01-01T12:00:00-05:00",
                "disableWeekends": false,
                "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "validate": {
                "customMessage": "INGRESA UNA FECHA VÁLIDA"
            },
            "key": "fechaDeConstitucionContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaMoral"
            },
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": true,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2021-01-01T12:00:00-05:00"
            }
        }
    ],
    "slice_type": "step__grupopregunta",
    "slice_label": null
}


export const dataForm = {
    formResponses: [
        {
            "label": "Aliado",
            "defaultValue": "COTIZADORES_SURA",
            "key": "claveAliado",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": "COTIZADORES_SURA"
        },
        {
            "label": "EL IMC ES DE",
            "placeholder": "0.0 m",
            "suffix": "m",
            "spellcheck": false,
            "disabled": true,
            "tableView": false,
            "calculateValue": {
                "operation": "peso/(talla*talla)",
                "fields": [
                    "peso",
                    "talla"
                ]
            },
            "validate": {
                "required": true,
                "minLength": 1,
                "maxLength": 6
            },
            "key": "imc",
            "properties": {
                "fixed": "3"
            },
            "type": "textfield",
            "input": true,
            "value": "27.682"
        },
        {
            "label": "¿Eres fumador?",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true,
                "customMessage": "Error"
            },
            "key": "esFumador",
            "type": "checkbox",
            "input": true,
            "value": false
        },
        {
            "label": "FECHA DE NACIMIENTO",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
                "minDate": "1870-01-01T12:00:00-04:56",
                "maxDate": "2021-01-01T12:00:00-05:00",
                "disableWeekends": false,
                "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "validate": {
                "required": true,
                "customMessage": "INGRESA UNA FECHA VÁLIDA"
            },
            "key": "fechaNacimiento",
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": true,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2021-01-01T12:00:00-05:00"
            },
            "value": "1990-01-01"
        },
        {
            "label": "OCUPACIÓN",
            "widget": "choicesjs",
            "placeholder": "Elige tu ocupación ",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "claveOcupacion",
            "type": "select",
            "input": true,
            "value": "A392"
        },
        {
            "label": "PESO EN KILOGRAMOS",
            "placeholder": "Ej: 00.000 Kg",
            "suffix": "Kg",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "[0-9][0-9]\\.[0-9][0-9][0-9]",
                "customMessage": "Ingrese un peso correcto Ej: 99.999",
                "minLength": 1,
                "maxLength": 6
            },
            "key": "peso",
            "properties": {
                "fixed": "3"
            },
            "type": "textfield",
            "input": true,
            "value": "80.000"
        },
        {
            "label": "ALTURA EN METROS",
            "placeholder": "Ej: 0.00 m",
            "suffix": "m",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "[0-9]\\.[0-9][0-9]",
                "customMessage": "Ingrese una altura correcta Ej: 1.80",
                "minLength": 1,
                "maxLength": 4
            },
            "key": "talla",
            "type": "textfield",
            "input": true,
            "value": "1.70"
        },
        {
            "label": "Genero",
            "optionsLabelPosition": "right",
            "customClass": "radioImage",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Hombre",
                    "value": "H",
                    "shortcut": ""
                },
                {
                    "label": "Mujer",
                    "value": "M",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "genero",
            "properties": {
                "H": "https://images.prismic.io/portal-cotizacion-suramex/0399ebf0-3ec8-4cf6-9f70-0f1105be2022_men.png?auto=compress,format",
                "M": "https://images.prismic.io/portal-cotizacion-suramex/4cb0207a-34b8-41c3-b8f0-1c94de47c94e_women.png?auto=compress,format"
            },
            "type": "radio",
            "input": true,
            "value": "H"
        },
        {
            "label": "¿Tienes mascotas?",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true
            },
            "key": "incluyeMascotas",
            "type": "checkbox",
            "input": true,
            "value": false
        },
        {
            "label": "Familia",
            "optionsLabelPosition": "right",
            "customClass": "radioImage",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Soltero(a)",
                    "value": "T",
                    "shortcut": ""
                },
                {
                    "label": "Pareja sin hijos",
                    "value": "F",
                    "shortcut": ""
                },
                {
                    "label": "Pareja con hijos",
                    "value": "H",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "claveTipoFamilia",
            "properties": {
                "T": "https://images.prismic.io/portal-cotizacion-suramex/a81f3af0-a49a-4a1b-b4d4-b3f5cc367095_solteros.png?auto=compress,format",
                "F": "https://images.prismic.io/portal-cotizacion-suramex/ffe662ac-b650-430a-9750-7c2d6b612171_parejasinhijos.png?auto=compress,format",
                "H": "https://images.prismic.io/portal-cotizacion-suramex/5144744e-ff1e-4825-ae75-b5d54c1bc20a_parejaconhijos.png?auto=compress,format"
            },
            "type": "radio",
            "input": true,
            "value": "T"
        },
        {
            "label": "¿POR CUANTO TIEMPO QUIERES CONTRATAR TU SEGURO?",
            "widget": "choicesjs",
            "placeholder": "años",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "1 años",
                        "value": "1Anos"
                    },
                    {
                        "label": "5 años",
                        "value": "5Anos"
                    },
                    {
                        "label": "10 años",
                        "value": "10Anos"
                    },
                    {
                        "label": "15 años",
                        "value": "15Anos"
                    },
                    {
                        "label": "20 años",
                        "value": "20Anos"
                    },
                    {
                        "label": "25 años",
                        "value": "25Anos"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "tiempoContratoSeguro",
            "type": "select",
            "input": true,
            "value": "1Anos"
        },
        {
            "label": "¿En qué monedas quieres tus coberturas?",
            "widget": "choicesjs",
            "placeholder": "Ej: pesos",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "USD - Dólares",
                        "value": "USD"
                    },
                    {
                        "label": "MXN - Pesos",
                        "value": "MXN"
                    },
                    {
                        "label": "UDIs",
                        "value": "UDI"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "monedaId",
            "type": "select",
            "input": true,
            "value": "MXN"
        },
        {
            "label": "Coberturas",
            "optionsLabelPosition": "right",
            "tableView": false,
            "defaultValue": {
                "1": false,
                "": false,
                "{": false
            },
            "values": [
                {
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&incluyeMascotas=value&page=1\",   \"method\": \"GET\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"x-api-key\": \"09e5ece8bcbf4ff4b1d099fb45e7b3bc\"   },   \"body\": {} }",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "coberturas",
            "type": "selectboxes",
            "input": true,
            "inputType": "checkbox",
            "value": [
                {
                    "nombre": "FALLECIMIENTO",
                    "claveCobertura": "9190",
                    "obligatorio": true,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 50,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 15000000,
                            "sumaAseguradaPredeterminada": 700000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 750000,
                            "sumaAseguradaPredeterminada": 35000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 2307692,
                            "sumaAseguradaPredeterminada": 107692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "BÁSICA",
                    "asegurados": [],
                    "page": "1",
                    "img": "1bc7889b-c5d4-4d78-9470-03586d70bc5d_fallecimiento.png",
                    "descripcion": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada",
                    "value": 700000
                },
                {
                    "nombre": "GASTOS FUNERARIOS",
                    "claveCobertura": "9198",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 58,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 20000,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 1000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 3077,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "RECOMENDADA",
                    "asegurados": [
                        {
                            "claveAsegurado": "T",
                            "dsAsegurado": "Para mí",
                            "porcentajeExtraPrima": null
                        },
                        {
                            "claveAsegurado": "H",
                            "dsAsegurado": "Para mí y mis hijos",
                            "porcentajeExtraPrima": null
                        },
                        {
                            "claveAsegurado": "C",
                            "dsAsegurado": "Para mí y mi cónyuge",
                            "porcentajeExtraPrima": null
                        },
                        {
                            "claveAsegurado": "F",
                            "dsAsegurado": "Para mí, mi cónyuge y mis hijos (menores de 18 años)",
                            "porcentajeExtraPrima": 0
                        }
                    ],
                    "page": "1",
                    "img": "165c1ef4-eb6f-443b-908c-fedaa4ba20d7_gastos-funerarios.png",
                    "descripcion": null,
                    "checks": "T",
                    "value": 50000
                }
            ],
            "valueResponse": [
                {
                    "nombre": "FALLECIMIENTO",
                    "claveCobertura": "9190",
                    "obligatorio": true,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 50,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 15000000,
                            "sumaAseguradaPredeterminada": 700000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 750000,
                            "sumaAseguradaPredeterminada": 35000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 2307692,
                            "sumaAseguradaPredeterminada": 107692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "BÁSICA",
                    "asegurados": [],
                    "page": "1",
                    "img": "1bc7889b-c5d4-4d78-9470-03586d70bc5d_fallecimiento.png",
                    "descripcion": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada",
                    "value": 700000
                },
                {
                    "nombre": "MUERTE ACCIDENTAL",
                    "claveCobertura": "9191",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 51,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 15000000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 750000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 2307692,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "09a1d894-88f9-4004-94c3-f53ba18861cf_fallecimiento-accidental.png",
                    "descripcion": "Pagamos a los beneficiarios una suma asegurada adicional en caso de que el fallecimiento del asegurado ocurra en un accidente."
                },
                {
                    "nombre": "MUERTE COLECTIVA",
                    "claveCobertura": "9192",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 52,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 15000000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 750000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 2307692,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "93735dd6-6921-41c4-ae53-5a8204aee87a_exencionpagos-primas-invalidez.png",
                    "descripcion": "Pagamos a los beneficiarios una suma asegurada adicional en caso de que el fallecimiento del asegurado ocurra a causa de un accidente como pasajeroen transporte terrestre público."
                },
                {
                    "nombre": "INVALIDEZ TOTAL Y PERMANENTE",
                    "claveCobertura": "9193",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 53,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 15000000,
                            "sumaAseguradaPredeterminada": 1500000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 750000,
                            "sumaAseguradaPredeterminada": 75000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 2307692,
                            "sumaAseguradaPredeterminada": 230769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "93735dd6-6921-41c4-ae53-5a8204aee87a_exencionpagos-primas-invalidez.png",
                    "descripcion": null
                },
                {
                    "nombre": "EXCENCIÓN PAGO PRIMA INVALIDEZ",
                    "claveCobertura": "9194",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 54,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 15000000,
                            "sumaAseguradaPredeterminada": 700000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 750000,
                            "sumaAseguradaPredeterminada": 35000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 2307692,
                            "sumaAseguradaPredeterminada": 107692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "93735dd6-6921-41c4-ae53-5a8204aee87a_exencionpagos-primas-invalidez.png",
                    "descripcion": "En caso de sufrir un accidende o enfermedad que te provoque invalidez total y permanente, seguirás pretegido por fallecimiento, pero sin pagar primas."
                },
                {
                    "nombre": "PÉRDIDAS ORGÁNICAS",
                    "claveCobertura": "9195",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 55,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 15000000,
                            "sumaAseguradaPredeterminada": 1500000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 750000,
                            "sumaAseguradaPredeterminada": 75000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 2307692,
                            "sumaAseguradaPredeterminada": 230769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "ed8ae343-5a2b-4435-b9af-4833df9444b5_perdidas-organicas.png",
                    "descripcion": "Indemnizaos al asegurado en caso de sufrir la pérdida de alguna parte del cuerpo a consecuencia de un accidente, de acuerdo al tipo de pérdida sufrida"
                },
                {
                    "nombre": "RENTA DIARIA HOSPITALIZACIÓN",
                    "claveCobertura": "9196",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 56,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 120,
                            "sumaAseguradaMaxima": 150000,
                            "sumaAseguradaPredeterminada": 1000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 6,
                            "sumaAseguradaMaxima": 75,
                            "sumaAseguradaPredeterminada": 50,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 18,
                            "sumaAseguradaMaxima": 231,
                            "sumaAseguradaPredeterminada": 154,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "b0021f78-fc03-46e8-a167-f98b63d4a9d0_indemnizacion-diaria-hospitaliza.png",
                    "descripcion": "En caso de estar hospitalizado a causa de una enfermedad o accidente, contarás con un apoyo económico."
                },
                {
                    "nombre": "ENFERMEDADES GRAVES",
                    "claveCobertura": "9197",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 57,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 3000000,
                            "sumaAseguradaPredeterminada": 375000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 150000,
                            "sumaAseguradaPredeterminada": 18750,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 461538,
                            "sumaAseguradaPredeterminada": 57692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "11846a60-ae40-466a-823f-4a5bd9710a71_enfermedades-graves.png",
                    "descripcion": "Si eres diagnosticado por primera vez con alguna de las 9 enfermedades graves cubiertas, se te pagará la suma asegurada contratada para esta cobertura."
                },
                {
                    "nombre": "GASTOS FUNERARIOS",
                    "claveCobertura": "9198",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 58,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 20000,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 1000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 3077,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "RECOMENDADA",
                    "asegurados": [
                        {
                            "claveAsegurado": "T",
                            "dsAsegurado": "Para mí",
                            "porcentajeExtraPrima": null
                        },
                        {
                            "claveAsegurado": "H",
                            "dsAsegurado": "Para mí y mis hijos",
                            "porcentajeExtraPrima": null
                        },
                        {
                            "claveAsegurado": "C",
                            "dsAsegurado": "Para mí y mi cónyuge",
                            "porcentajeExtraPrima": null
                        },
                        {
                            "claveAsegurado": "F",
                            "dsAsegurado": "Para mí, mi cónyuge y mis hijos (menores de 18 años)",
                            "porcentajeExtraPrima": 0
                        }
                    ],
                    "page": "1",
                    "img": "165c1ef4-eb6f-443b-908c-fedaa4ba20d7_gastos-funerarios.png",
                    "descripcion": null,
                    "checks": "T",
                    "value": 50000
                }
            ]
        },
        {
            "label": "Coberturas adicionales",
            "optionsLabelPosition": "right",
            "tableView": false,
            "defaultValue": {
                "1": false,
                "": false,
                "{": false
            },
            "values": [
                {
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&incluyeMascotas=value&page=2\",   \"method\": \"GET\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"x-api-key\": \"09e5ece8bcbf4ff4b1d099fb45e7b3bc\"   },   \"body\": {} }",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "coberturasAdicionales",
            "type": "selectboxes",
            "input": true,
            "inputType": "checkbox",
            "value": [],
            "valueResponse": [
                {
                    "nombre": "PROTECCIÓN ADICIONAL POR FALLECIMIENTO",
                    "claveCobertura": "9202",
                    "obligatorio": false,
                    "dependencia": "9190",
                    "claveSumaAseguradaCapital": 60,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "USD": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "UDI": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": 20
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "43baa024-7f7b-4761-9953-707fa0b57f73_proteccion-adicional-fallecimiento.png",
                    "descripcion": null
                },
                {
                    "nombre": "PROTECCIÓN ADICIONAL POR INVALIDEZ",
                    "claveCobertura": "9203",
                    "obligatorio": false,
                    "dependencia": "9193",
                    "claveSumaAseguradaCapital": 61,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "USD": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "UDI": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": 20
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "67f0f895-8bfd-4812-ae47-ee5550a92f1b_proteccion-adicional-invalidez.png",
                    "descripcion": "En caso de sufir algún accidente o enfermedad que te provoque una invalidez total y permanente, recibirás la suma asegurada contratada."
                }
            ]
        },
        {
            "label": "HE LEÍDO Y ACEPTO EL <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">AVISO DE PRIVACIDAD</A>",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true
            },
            "key": "avisoPrivacidad",
            "type": "checkbox",
            "input": true,
            "value": true
        },
        {
            "label": "Nombre",
            "placeholder": "Ej. Diana",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                "customMessage": "Ingresa un nombre valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "nombre",
            "type": "textfield",
            "input": true,
            "value": "sdfdsf"
        },
        {
            "label": "INGRESA TU E-MAIL",
            "placeholder": "ejemplo@gmail.com",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                "customMessage": "Ingrese un correo electrónico valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "email",
            "type": "textfield",
            "input": true,
            "value": "sdfsd@gmail.com"
        },
        {
            "label": "TELÉFONO CELULAR",
            "placeholder": "Ej. 555723799",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "1?-?\\(?[0-9]{3}[0-9]{3}[0-9]{4}",
                "customMessage": "Ingresa un número telefónico valido",
                "minLength": 1,
                "maxLength": 10
            },
            "key": "telefono",
            "type": "textfield",
            "input": true,
            "value": "3546546526"
        },
        {
            "label": "No soy un robot",
            "customClass": "recaptcha",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true
            },
            "key": "noSoyUnRobot",
            "properties": {
                "sitekey": "6LdCNUMaAAAAAM3W7I7d9dsG9WXPb-0W0v7f9n9G"
            },
            "type": "checkbox",
            "input": true,
            "value": true
        },
        {
            "label": "Planes",
            "optionsLabelPosition": "right",
            "customClass": "selectboxesPlans",
            "tableView": false,
            "defaultValue": {
                "api": false,
                "apiService": false,
                "{": false
            },
            "values": [
                {
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/cotizacion\",   \"method\": \"POST\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"x-api-key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "planes",
            "type": "selectboxes",
            "input": true,
            "inputType": "checkbox",
            "value": [
                {
                    "paquete": "Mi Plan Vive",
                    "valor": 1375.07,
                    "asistencias": "Asistencia básica (legal, médica, funeraria y repatriación)",
                    "tooltip": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada.",
                    "descripcion": "Tu seguro de vida personalizado con las Coberturas que elegiste.",
                    "coberturas": [
                        {
                            "claveCobertura": "9198",
                            "sumaAsegurada": 50000,
                            "atrRecargoCobertura": 0,
                            "porcentajeExtraPrima": "1.5",
                            "claveSumaAseguradaCapital": 58
                        },
                        {
                            "claveCobertura": "9190",
                            "sumaAsegurada": 700000,
                            "atrRecargoCobertura": 0,
                            "porcentajeExtraPrima": "0",
                            "claveSumaAseguradaCapital": 50
                        },
                        {
                            "claveCobertura": "9206",
                            "sumaAsegurada": 0,
                            "atrRecargoCobertura": 0,
                            "porcentajeExtraPrima": "0",
                            "claveSumaAseguradaCapital": 64
                        }
                    ]
                }
            ]
        },
        {
            "label": "Fecha de nacimiento",
            "tableView": true,
            "customDefaultValue": "fechaNacimiento",
            "validate": {
                "required": true
            },
            "key": "fechaDeNacimiento",
            "type": "textfield",
            "input": true,
            "value": "1990-01-01"
        },
        {
            "label": "Ocupación o profesión",
            "widget": "choicesjs",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "claveOcupacion",
            "key": "ocupacionProfesion",
            "type": "select",
            "input": true,
            "value": "A392"
        },
        {
            "label": "¿Empleado gubernamental?",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true,
                "customMessage": "Error"
            },
            "key": "empleadoGubernamental",
            "type": "checkbox",
            "input": true,
            "value": false
        },
        {
            "label": "INGRESA TU E-MAIL",
            "placeholder": "ejemplo@gmail.com",
            "tableView": true,
            "customDefaultValue": "email",
            "validate": {
                "required": true,
                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                "customMessage": "Ingrese un correo electrónico valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "email1",
            "type": "textfield",
            "input": true,
            "value": "sdfsd@gmail.com"
        },
        {
            "label": "TELÉFONO CELULAR",
            "placeholder": "Ej. 55 5723 799",
            "tableView": true,
            "customDefaultValue": "telefono",
            "validate": {
                "required": true,
                "pattern": "1?-?\\(?[0-9]{3}[0-9]{3}[0-9]{4}",
                "customMessage": "Ingresa un número telefónico valido",
                "minLength": 1,
                "maxLength": 10
            },
            "key": "telefono1",
            "type": "textfield",
            "input": true,
            "value": "3546546526"
        },
        {
            "label": "¿Otras nacionalidades?",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "customMessage": "Error"
            },
            "key": "otrasNacionalidades",
            "conditional": {
                "show": false,
                "when": "pais",
                "eq": "052"
            },
            "type": "checkbox",
            "input": true,
            "value": false
        },
        {
            "label": "¿Residente fiscal en el extranjero?",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "customMessage": "Error"
            },
            "key": "residenteFiscalExtranjero",
            "conditional": {
                "show": false,
                "when": "pais",
                "eq": "052"
            },
            "type": "checkbox",
            "input": true,
            "value": false
        },
        {
            "label": "RFC",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z0-9]+$",
                "customMessage": "Dato no válido"
            },
            "key": "identificadorPersona",
            "type": "textfield",
            "input": true,
            "value": "CIPJ570214"
        },
        {
            "label": "Primer Nombre",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "primerNombre",
            "type": "textfield",
            "input": true,
            "value": "JOSE"
        },
        {
            "label": "Segundo Nombre",
            "tableView": true,
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "segundoNombre",
            "type": "textfield",
            "input": true,
            "value": "MANUEL"
        },
        {
            "label": "Apellido paterno",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "primerApellido",
            "type": "textfield",
            "input": true,
            "value": "tejada"
        },
        {
            "label": "Apellido materno",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "segundoApellido",
            "type": "textfield",
            "input": true,
            "value": "PEREZ"
        },
        {
            "label": "Género",
            "widget": "choicesjs",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Hombre",
                        "value": "H - HOMBRE"
                    },
                    {
                        "label": "Mujer",
                        "value": "M - MUJER"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "sexo",
            "type": "select",
            "input": true,
            "value": "H - HOMBRE"
        },
        {
            "label": "Código postal",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[0-9]*$",
                "customMessage": "MINIMO 5 CARACTERES",
                "minLength": 5,
                "maxLength": 5
            },
            "key": "codigoPostal",
            "type": "textfield",
            "input": true,
            "value": "97100"
        },
        {
            "label": "País de Nacimiento",
            "widget": "choicesjs",
            "placeholder": "Elige tu país de nacimiento",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "pais",
            "type": "select",
            "input": true,
            "value": "052 - MEXICO"
        },
        {
            "label": "Colonia",
            "widget": "choicesjs",
            "placeholder": "Elige la colonia",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostal=value&catalogo=COLONIA",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "colonia",
            "type": "select",
            "input": true,
            "value": "31A28 - ITZIMNA"
        },
        {
            "label": "CURP",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z0-9]+$",
                "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                "minLength": 18,
                "maxLength": 18
            },
            "key": "curp",
            "type": "textfield",
            "input": true,
            "value": "654654654446856456"
        },
        {
            "label": "Estado Civil",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Soltero/a.",
                        "value": "solteroA"
                    },
                    {
                        "label": "Casado/a.",
                        "value": "casadoA"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "estadoCivil",
            "type": "select",
            "input": true,
            "value": "solteroA"
        },
        {
            "label": "Lugar de Nacimiento",
            "placeholder": "Lugar de Nacimiento",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 40
            },
            "key": "lugarNacimiento",
            "type": "textfield",
            "input": true,
            "value": "df"
        },
        {
            "label": "Nacionalidad",
            "placeholder": "Nacionalidad",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "nacionalidad",
            "type": "textfield",
            "input": true,
            "value": "dfs"
        },
        {
            "label": "Puesto",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "puesto",
            "type": "textfield",
            "input": true,
            "value": "a"
        },
        {
            "label": "Ingresos mensuales",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[0-9]*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 7
            },
            "key": "ingresosMensuales",
            "type": "textfield",
            "input": true,
            "value": "3546"
        },
        {
            "label": "Descripción de actividades",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 70
            },
            "key": "descripcionActividades",
            "type": "textfield",
            "input": true,
            "value": "ssdf"
        },
        {
            "label": "Teléfono particular",
            "placeholder": "Ej. 55 5723 799",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "1?-?\\(?[0-9]{3}[0-9]{3}[0-9]{4}",
                "customMessage": "Ingresa un número telefónico valido",
                "minLength": 1,
                "maxLength": 10
            },
            "key": "telefonoParticular",
            "type": "textfield",
            "input": true,
            "value": "4654654556"
        },
        {
            "label": "E.Firma",
            "tableView": true,
            "validate": {
                "pattern": "[a-zA-Z0-9]",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 35
            },
            "key": "eFirma",
            "type": "textfield",
            "input": true,
            "value": "sdf"
        },
        {
            "label": "Tipo de identificación entregada",
            "widget": "choicesjs",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Credencial para votar vigente",
                        "value": "credencialParaVotarVigente"
                    },
                    {
                        "label": "Pasaporte vigente",
                        "value": "pasaporteVigente"
                    },
                    {
                        "label": "Cedula profesional",
                        "value": "cedulaProfesional"
                    },
                    {
                        "label": "Cartilla de servicio militar",
                        "value": "cartillaDeServicioMilitar"
                    },
                    {
                        "label": "Certificado de matrícula consultar para extranjeros",
                        "value": "certificadoDeMatriculaConsultarParaExtranjeros"
                    },
                    {
                        "label": "Documento migratorio vigente",
                        "value": "documentoMigratorioVigente"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "tipoDeIdentificacionEntregada",
            "type": "select",
            "input": true,
            "value": "credencialParaVotarVigente"
        },
        {
            "label": "País y entidad que expide el documento",
            "widget": "choicesjs",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "paisEntidadExpideDocumento",
            "type": "select",
            "input": true,
            "value": "052"
        },
        {
            "label": "Folio de identificación entregada",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "folioDeIdentificacionEntregada",
            "type": "textfield",
            "input": true,
            "value": "a"
        },
        {
            "label": "Dirección",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 50
            },
            "key": "direccion",
            "type": "textfield",
            "input": true,
            "value": "as"
        },
        {
            "label": "No. Exterior",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "[a-zA-Z0-9]",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 6
            },
            "key": "nExterior",
            "type": "textfield",
            "input": true,
            "value": "56465"
        },
        {
            "label": "No. interior",
            "tableView": true,
            "validate": {
                "pattern": "[a-zA-Z0-9]",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 6
            },
            "key": "nIterior",
            "type": "textfield",
            "input": true,
            "value": "546"
        },
        {
            "label": "Estado",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido"
            },
            "key": "estado",
            "type": "textfield",
            "input": true,
            "value": "sdf"
        },
        {
            "label": "Domicilio en el extranjero",
            "tableView": true,
            "validate": {
                "pattern": "^[a-zA-Z-ñÑ]+$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 50
            },
            "key": "domicilioEnElExtranjero",
            "type": "textfield",
            "input": true,
            "value": "sgd"
        },
        {
            "label": "País domicilio en el extranjero",
            "widget": "choicesjs",
            "placeholder": "Elige tu país de domicilio en el extranjero",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "x-api-key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                    },
                    "body": {}
                }
            },
            "validate": {
                "customMessage": "Este campo es requerido"
            },
            "key": "paisDomicilioEnElExtranjero",
            "type": "select",
            "input": true,
            "value": "052"
        },
        {
            "label": "Teléfono (con clave lada)",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[0-9]*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 15
            },
            "key": "telefonoExtranjero",
            "type": "textfield",
            "input": true,
            "value": "564654"
        },
        {
            "label": "Cuénta con otro seguro de vida contratado de forma voluntaria?",
            "optionsLabelPosition": "right",
            "customClass": "radioText",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Si",
                    "value": "si",
                    "shortcut": ""
                },
                {
                    "label": "No",
                    "value": "no",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria",
            "type": "radio",
            "input": true,
            "value": "no"
        },
        {
            "label": "Le han rechazado, limitado o extra-primado alguna solicitud?",
            "optionsLabelPosition": "right",
            "customClass": "radioText",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Si",
                    "value": "si",
                    "shortcut": ""
                },
                {
                    "label": "No",
                    "value": "no",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "leHanRechazadoLimitadoOExtraPrimadoAlgunaSolicitud",
            "type": "radio",
            "input": true,
            "value": "no"
        }
    ], hiddenFields: [],
    disabledFields: {}
};

export const setDataForm = () => { }

export const checked = true;

export const setChecked = () => { };